<template>
  <div>
    <h1>{{ t("mergeClients-title") }}</h1>
    <p>{{ t("mergeClients-description") }}</p>
    <select v-model="field">
      <option value="external_id">{{ t("mergeClients-fieldExternalId") }}</option>
      <option value="email">{{ t("mergeClients-fieldEmail") }}</option>
      <option value="whatsapp">{{ t("mergeClients-fieldWhatsapp") }}</option>
    </select>
    <button @click="previewMerge">{{ t("mergeClients-previewButton") }}</button>
    <div v-if="uniqueValues.length" class="box my-4">
      <h2>{{ t("mergeClients-previewTitle") }}</h2>
      <table class="table">
        <thead>
          <tr>
            <th>{{fieldLabel}}</th>
            <th>{{ t("mergeClients-clientsColumn") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(clients, value) in preview" :key="value">
            <td>{{ value }}</td>
            <td>
                <table class="table">
                  <tbody>
                    <tr>
                      <td v-for="client in clients" :key="client.id">
                        <div>{{ t("mergeClients-nameLabel") }}: {{ client.first_name }} {{ client.last_name }}</div>
                        <div>{{ t("mergeClients-emailLabel") }}: {{ client.email }}</div>
                        <div>{{ t("mergeClients-whatsappLabel") }}: {{ client.whatsapp }}</div>
                        <div v-for="(field, idx) in client.fields" :key="idx" v-show="field">
                          <div v-if="field">
                            {{field.field_name}}: {{field.value}}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <button @click="mergeClients" :disabled="merging">{{ t("mergeClients-mergeButton") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import keviApi from "../keviApi";
export default {
  data() {
    return {
      field: null,
      preview: {},
      merging: false,
      /**
       * {
       *     "clients": {
       *         "(11) 97178-1708": [
       *             {
       *                 "id": "222818556798000003",
       *                 "first_name": "ROSA MARIA GABRIEL",
       *                 "last_name": "BRANCO",
       *                 "email": null,
       *                 "password": null,
       *                 "whatsapp": "(11) 97178-1708",
       *                 "birthdate": "Wed, 17 Jan 1962 00:00:00 -0300",
       *                 "cpf": null,
       *                 "fbId": null,
       *                 "created_at": "2024-10-15 17:02:36",
       *                 "places_id": "18150870966000001",
       *                 "external_id": null,
       *                 "external_source": "Admin",
       *                 "subscribed_sms": "1",
       *                 "subscribed_whatsapp": "1",
       *                 "subscribed_email": "1",
       *                 "rfm_score_r": null,
       *                 "rfm_score_f": null,
       *                 "rfm_score_m": null,
       *                 "rfm_score": null,
       *                 "rfm_segment": null,
       *                 "last_rfm_updated_date": null,
       *                 "clients_stages_id": null,
       *                 "places_branches_id": null,
       *                 "clients_to_delete_id": null,
       *                 "to_be_processed": null,
       *                 "orders_id": null,
       *                 "orders": "0",
       *                 "last_order": null,
       *                 "answers": "0",
       *                 "last_answer": null,
       *                 "custom_events": "0",
       *                 "last_custom_event": null,
       *                 "most_recent_action": 1729022556
       *             },
       *             {
       *                 "id": "222818556800000004",
       *                 "first_name": "ROSA MARIA GABRIEL",
       *                 "last_name": "BRANCO",
       *                 "email": null,
       *                 "password": null,
       *                 "whatsapp": "(11) 97178-1708",
       *                 "birthdate": "Wed, 17 Jan 1962 00:00:00 -0300",
       *                 "cpf": null,
       *                 "fbId": null,
       *                 "created_at": "2024-10-15 17:02:36",
       *                 "places_id": "18150870966000001",
       *                 "external_id": null,
       *                 "external_source": "Admin",
       *                 "subscribed_sms": "1",
       *                 "subscribed_whatsapp": "1",
       *                 "subscribed_email": "1",
       *                 "rfm_score_r": null,
       *                 "rfm_score_f": null,
       *                 "rfm_score_m": null,
       *                 "rfm_score": null,
       *                 "rfm_segment": null,
       *                 "last_rfm_updated_date": null,
       *                 "clients_stages_id": null,
       *                 "places_branches_id": null,
       *                 "clients_to_delete_id": null,
       *                 "to_be_processed": null,
       *                 "orders_id": null,
       *                 "orders": "0",
       *                 "last_order": null,
       *                 "answers": "0",
       *                 "last_answer": null,
       *                 "custom_events": "0",
       *                 "last_custom_event": null,
       *                 "most_recent_action": 1729022556
       *             }
       *         ]
       *     }
       * }
       */
    };
  },
  computed: {
    uniqueValues() {
      if (this.preview && this.preview) {
        return Object.keys(this.preview);
      }
      return [];
    },
    fieldLabel() {
      switch (this.field) {
        case "external_id":
          return this.t("mergeClients-fieldExternalId");
        case "email":
          return this.t("mergeClients-fieldEmail");
        case "whatsapp":
          return this.t("mergeClients-fieldWhatsapp");
        default:
          return "";
      }
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    async previewMerge() {
      if (this.field === null) {
        alert(this.t("mergeClients-selectFieldAlert"));
        return;
      }
      const options = keviApi.getOptions("merge-clients/preview","GET", {
        field: this.field,
      });
      this.$http(options).then((response) => {
        const clients = response.data.clients || {};
        this.preview = clients;
      });
    },
    async mergeClients() {
      if (this.field === null) {
        alert(this.t("mergeClients-selectFieldAlert"));
        return;
      }
      const options = keviApi.getOptions("merge-clients","post", {
        field: this.field,
      });
      this.merging = true;
      this.$http(options).then(() => {
        this.previewMerge();
        alert(this.t("mergeClients-mergeSuccessAlert"));
      }).finally(() => {
        this.merging = false;
      });
    },
  },
};
</script>
<style scoped lang="scss">

</style>
